import { Component, Input, OnInit, OnDestroy, Output, EventEmitter, NgZone } from '@angular/core';
import { PersonInsightsData } from '../hire-person-search/hire-insights/PersonInsightsData';
import { GlobalService } from 'src/app/_services/global.service';
import { AggregationService } from '../_services/aggregation.service';
import { environment } from '../../environments/environment';
import { LocalStorageService } from '../_services/local-storage.service';

import { Subscription } from 'rxjs'
import { LoaderEventsService } from '../_services/loader-events.service';
import { LoaderType } from '../enums/LoaderType';
import { ActivatedRoute, Router } from '@angular/router';
import { FilterDataHandlerService } from '../_services/filter-data-handler.service';
import { ExportPayload, ExportRequest, PersonSearchService } from '../_services/person-search.service';
import { SimilarCandidateService } from '../_services/similar-candidate.service';
import { FusionChartsService } from '../_services/fusion-charts.service';
import { ContinentHandlerService } from '../_services/continent-handler.service';
import { StatsMatrixHandlerService } from '../_services/stats-matrix-handler.service';


declare var google;
const CONTINENT_MAP = {
  "asia": "142",
  "south america": "005",
  "north america": "021",
  "africa": "002",
  "oceania": "009",
  "europe": "150"
}

@Component({
  selector: 'app-person-search-insights',
  templateUrl: './person-search-insights.component.html',
  styleUrls: ['./person-search-insights.component.scss'],
  standalone: false
})
export class PersonSearchInsightsComponent implements OnInit, OnDestroy {

  @Input() searchHistoryRegion: any;
  personInsightsData: PersonInsightsData = {};
  currentCompanyInformation: CurrentCompanyInformation = {};
  subs: Subscription[] = [];
  @Output() insightsEvents = new EventEmitter<{ action: string, data: any }>();
  @Input() similarContinent: string;
  similarType: string;

  /**Need to send data for openAI (send doc_count insetead of percent) */
  nationalityEthnicityData = {};
  changeContinent: string;

  insightsExportSubscription: Subscription = null;
  @Input() projectnumber: string;
  @Input() aiSourcingContinent: string;
  totalCandidatesCount: number = 0;
  totalMedianTanureCount: number = 0;
  malePercent: any = null;
  femalePercent: any = null;
  changedJobs: any = null;
  likelyToMoveInCountAvailable: boolean = false;
  medianTenureInCountAvailable: boolean = false;
  genderDataAvailable: boolean = false;
  changedJobsCountAvailable: boolean = false;
  currentURL: string = this.router.url;
  @Input() calledFrom: string;

  // Note : localstorageservice is being used with the help of bind method in load google maps method
  constructor(
    private fusionChartService: FusionChartsService,
    private aggregationService: AggregationService,
    private localstorageservice: LocalStorageService,
    private loaderEventService: LoaderEventsService,
    private personsearchservice: PersonSearchService,
    private filterDataHandlerService: FilterDataHandlerService,
    private similarCandidateService: SimilarCandidateService,
    private route: ActivatedRoute,
    private continentHandlerService: ContinentHandlerService,
    private statsMatrixHandlerService: StatsMatrixHandlerService,
    private router: Router,
    private ngZone: NgZone,
  ) {
    this.projectnumber = this.projectnumber || location.pathname?.split('/')[2];
    if (this.projectnumber) {
      this.aggregationService.getTotalAggsAISourcing(this.projectnumber);

    } else {
      this.aggregationService.getTotalAggs();
    }
  }

  ngOnInit() {
   // this.aggregationService.getStatsAggs();
    const statsUpdateSub = this.aggregationService.statsUpdateEvent.subscribe(res => this.setMatrixStats(res));
    this.subs.push(statsUpdateSub);

    const insightsDataEvent = this.aggregationService.insightsDataEvent.subscribe(data => {
      this.processIndividualData(data)
    });
    this.subs.push(insightsDataEvent);

    const loaderEvent = this.loaderEventService.loaderEvent.subscribe(event => {
      if (event === LoaderType.INSIGHTS) { this.personInsightsData = {}; }
    });
    this.subs.push(loaderEvent);
    this.similarType = this.route.snapshot.queryParams['type'];

    const continentUpdateSub = this.continentHandlerService.continentUpdateObservable.subscribe(continent => this.changeContinent = continent);
    this.subs.push(continentUpdateSub);

    // subscribe to insights-export subject for processing request from parent
    this.insightsExportSubscription = this.personsearchservice.insightsExportRequestEvent.subscribe((requestData: ExportRequest) => {
      if (requestData && requestData.type === 'SIGNAL') {
        this.shareDataForInsightsExport(requestData);
      }
    });
    this.subs.push(this.insightsExportSubscription);

  }

  private processIndividualData(data: any) {
    let agg = data?.data?.aggregations;
    if (data?.status !== "success" || !agg)
      return;

    const key = Object.keys(agg)[0];
    data[key] = data?.data?.aggregations[key];
    this.personInsightsData = this.aggregationService.processAggregationResponse(
      this.personInsightsData, data, { aggregatetype: key }
    );
    key === "location_name-location_continent" && setTimeout(() => this.loadGoogleMap(this.personInsightsData), 100);
    if ((this.personInsightsData && this.personInsightsData.topLocations) && (this.personInsightsData && this.personInsightsData.dataSourceCurrentCompany && this.personInsightsData.dataSourceCurrentCompany.data)
      && (this.personInsightsData && this.personInsightsData.currentIndustry)
      && (this.personInsightsData && this.personInsightsData.school) &&
      (this.personInsightsData && this.personInsightsData.fieldOfStudy) &&
      (this.personInsightsData && this.personInsightsData.skills) &&
      (this.personInsightsData && this.personInsightsData.titles) &&
      (this.personInsightsData && this.personInsightsData.dataSourceCurrentExperience && this.personInsightsData.dataSourceCurrentExperience.data) &&
      (this.personInsightsData && this.personInsightsData.dataSourceExpInCurrentRole && this.personInsightsData.dataSourceExpInCurrentRole.data) &&
      (this.personInsightsData && this.personInsightsData.dataSourceSeniority && this.personInsightsData.dataSourceSeniority.data)) {
      let eventData = { action: "aidata", data: this.personInsightsData }

      this.insightsEvents.emit(eventData);
    }
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  loadGoogleMap(personInsightsData: PersonInsightsData) {
    function drawMarkersMap() {
      try {
        var data = google.visualization.arrayToDataTable(
          personInsightsData.dataSourceWorkCountry
        );
        const continent = this.filterDataHandlerService.isRedirectFromTalentInsightsPage ? this.localstorageservice.getItem("talentRegion") : this.searchHistoryRegion ? this.searchHistoryRegion : this.similarCandidateService.isListingCalledFromSimilarCandidate ? this.similarContinent : this.localstorageservice.getItem("region");
        var options = {
          region: "world",
          displayMode: "markers",
          displayColor: 'red',
          colorAxis: { colors: this.fusionChartService.LOCATION_COLOR_PALETTE },
          // backgroundColor: "#f5f5f5",
        };
        const container = document.getElementById("workCountryChartDD");
        var chart = new google.visualization.GeoChart(container);
        chart.draw(data, options);
      } catch (error) {
        console.log('error in data visualisation in drawMakersMap :: ', error.message);
      }
    }


    google.charts.load('current', {
      'packages': ['geomap', 'geochart'],
      'mapsApiKey': environment.mapskey
    });
    google.charts.setOnLoadCallback(drawMarkersMap.bind(this));
  }

  getContinent() {
    if (this.changeContinent) {
      return this.changeContinent;
    } else if (this.filterDataHandlerService.isRedirectFromTalentInsightsPage) {
      return this.aggregationService.getRequestWithFilters()?.continentstobeincluded[0];
    } else if (this.searchHistoryRegion) {
      return this.searchHistoryRegion;
    } else if (this.similarCandidateService.isListingCalledFromSimilarCandidate) {
      return this.similarContinent;
    } else if (this.aiSourcingContinent) {
      return this.aiSourcingContinent;
    } else {
      return this.localstorageservice.getItem("region")
    }
  }


  getIndustryIcon(industryName) {
    let iconName = GlobalService.getIndustryIcon(industryName);
    return `text-webbtree-black fa-solid fa-${iconName}`;
  }

  getCompanyInfo(data: any) {
    let pastCompanyData = data;

    this.currentCompanyInformation['name'] = pastCompanyData?.name;
    this.currentCompanyInformation['industry'] = pastCompanyData?.industry;
    this.currentCompanyInformation['linkedin_url'] = pastCompanyData?.linkedin_url;
    this.currentCompanyInformation['location'] = pastCompanyData?.location?.name;
    this.currentCompanyInformation['size'] = pastCompanyData?.size;
    this.currentCompanyInformation['website'] = pastCompanyData?.website;
    this.currentCompanyInformation['companylogo'] = pastCompanyData.companylogo;
    this.currentCompanyInformation['tags'] = pastCompanyData.tags;
    this.currentCompanyInformation['id'] = pastCompanyData.id;
    this.currentCompanyInformation['facebook_url'] = pastCompanyData?.facebook_url;
    this.currentCompanyInformation['twitter_url'] = pastCompanyData?.twitter_url;
    this.currentCompanyInformation['github_url'] = pastCompanyData?.github_url;
  }

  /**
   * Handel Redirection to person search listing
   * @param type
   * @param data
   */
  handleRedirection(type: string, data: any) {
    this.handleChildEvents('redirect');
    this.filterDataHandlerService.setPersonSearchListingInsightsFilter(type, data);
  }

  /**
   * Handle fusion chart click
   * @param event
   * @param chartName
   */
  fusionChartsClickHandler(event: any, chartName: string) {
    event.eventObj.preventDefault();
    event.eventObj.stopPropagation();
    event.eventObj.detachHandler();
    const data = chartName == 'yearsofexperience' || chartName == 'currentyearsofexperience' ? event.dataObj.categoryLabel.match(/\d+/)[0] : event.dataObj.categoryLabel;

    this.handleRedirection(chartName, data);
  }

  /**
  * Handles all child events
  * @param action type of action
  */
  handleChildEvents(action: string) {
    let eventData = { action: action, data: {} }

    this.insightsEvents.emit(eventData)
  }

  /**
   * Share data with parent to initiate insights-export
   * @param requestData
   */
  shareDataForInsightsExport(requestData: ExportRequest) {
    if (requestData?.data?.currentTab !== 'insights') return;

    const overallTenureChart = { renderAt: 'overallTenureChart', type: 'column2d', width: '100%', dataSource: { ...this.personInsightsData?.dataSourceCurrentExperience || [] } };
    const currentTenureChart = { renderAt: 'currentCompanyChart', type: 'column2d', width: '100%', dataSource: { ...this.personInsightsData?.dataSourceExpInCurrentRole || [] } };
    // const talentNationalityChart = { renderAt: 'nationalityChart', type: 'bar2d', width: '100%', dataSource: { ...this.personInsightsData?.dataSourceNationality || [] } };
    // const talentEthnicityChart = { renderAt: 'ethnicityChart', type: 'doughnut2d', width: '100%', dataSource: { ...this.personInsightsData?.dataSourceEthnicity || [] } };
    const talentGenderChart = { renderAt: 'genderDiversityChart', type: 'doughnut2d', width: '100%', dataSource: { ...this.personInsightsData?.dataSourceGender || [] } };
    const talentSeniorityChart = { renderAt: 'seniorityChart', type: 'bar2d', width: '100%', dataSource: { ...this.personInsightsData?.dataSourceSeniority || [] } };

    const payloadForInsightsExport: ExportPayload = {
      toplocation: this.personInsightsData.topLocations.slice(0, 5),
      chartdetails: [{ type: 'google', data: this.personInsightsData?.dataSourceWorkCountry || [] }, overallTenureChart, currentTenureChart, /* talentNationalityChart, */ /* talentEthnicityChart, */ talentGenderChart, talentSeniorityChart],
      topcompanies: (this.personInsightsData?.dataSourceCurrentCompany?.data || []).slice(0, 5),
      topindustries: (this.personInsightsData?.currentIndustry || []).map(industry => ({ ...industry, icon: this.getIndustryIcon(industry.key) })).slice(0, 5),
      school: (this.personInsightsData?.school || []).slice(0, 5),
      fieldofstudy: (this.personInsightsData?.fieldOfStudy || []).slice(0, 5),
      skills: (this.personInsightsData?.skills || []).slice(0, 5),
      titles: (this.personInsightsData?.titles || []).slice(0, 5),
      continentstobeincluded: []
    }
    this.personsearchservice.sendInsightsExportData(payloadForInsightsExport);
  }

  private setMatrixStats(res: [any, any, any]) {
    let response = res.find(el => !!el?.data?.aggregations?.gender);
    const maleCount = response?.data && response?.data?.aggregations && response?.data?.aggregations?.gender && response?.data?.aggregations?.gender.filter(g => g.key == 'male')[0] && response.data.aggregations.gender.filter(g => g.key == 'male')[0].doc_count || 0;
    const femaleCount = response?.data && response?.data?.aggregations && response?.data?.aggregations?.gender && response?.data?.aggregations?.gender.filter(g => g.key == 'female')[0] && response.data.aggregations.gender.filter(g => g.key == 'female')[0].doc_count || 0;
    this.malePercent = maleCount ? ((maleCount / (maleCount + femaleCount)) * 100).toFixed(0) : 0;
    this.femalePercent = femaleCount ? ((femaleCount / (maleCount + femaleCount)) * 100).toFixed(0) : 0;
    const euTalentAccess = this.localstorageservice.getItem('hasEUTalentInsightsAccess');
    if (euTalentAccess)
      this.totalCandidatesCount = response?.data?.totalresultscount;
    this.statsMatrixHandlerService.setMatrixStaticData({ malePercent: this.malePercent, femalePercent: this.femalePercent });

    const filterData = this.filterDataHandlerService.fetchFilterData;

    response = res.find(el => !!el.data.aggregations.changedjobs);
    this.changedJobs = response?.data && response?.data?.aggregations && response?.data?.aggregations?.changedjobs && response?.data?.aggregations?.changedjobs?.doc_count;
    this.statsMatrixHandlerService.setMatrixStaticData({ changedJobs: this.changedJobs });

    response = res.find(el => !!el.data.aggregations.total_tenure_median);
    this.totalMedianTanureCount = response?.data && response?.data?.aggregations && response?.data?.aggregations?.total_tenure_median && response?.data?.aggregations?.total_tenure_median?.value;
    this.statsMatrixHandlerService.setMatrixStaticData({ totalMedianTanureCount: this.totalMedianTanureCount });

    this.ngZone.run(() => {
      this.setCountAvailableAll();
    })
  }


  private setCountAvailableAll() {
    this.likelyToMoveInCountAvailable = true;
    this.medianTenureInCountAvailable = true;
    this.genderDataAvailable = true;
    this.changedJobsCountAvailable = true;
  }

  formatNumberToIndianFormat(number: any): string {
    if (!number) return '0';
    const suffixes = ['', 'K+', 'M+', 'B+', 'T+'];
    for (const suffix of suffixes) {
      if (Math.abs(number) < 1000) return Math.floor(number) + suffix;
      number /= 1000;
    }
    return Math.floor(number) + 'T';
  }

  getFormattedTenureForMatrix(tenure: number): string {
    if (tenure == null) return '0';
    const totalYears = Math.floor(tenure);
    const totalMonths = Math.round((tenure - totalYears) * 12);
    const span = (t: string): string => {
      const s = document.createElement('span');
      s.className = 'median-tenure-text-size';
      s.innerHTML = t;
      return s.outerHTML;
    };
    if (totalYears > 0 && totalMonths > 0) {
      if (totalMonths === 12) return `${totalYears + 1} ${span(totalYears === 0 ? 'Yr' : 'Yrs')}`;
      return `${totalYears} ${span(totalYears === 1 ? 'Yr' : 'Yrs')} ${totalMonths} ${span('Mths')}`;
    }
    if (totalYears > 0) return `${totalYears} ${span(totalYears === 1 ? 'Yr' : 'Yrs')}`;
    if (totalMonths > 0) return totalMonths === 12 ? `1 ${span('Yr')}` : `${totalMonths} ${span('Mths')}`;
    return '';
  }

}
